<template>
  <div class="custom-tag-list">
    <el-tag
        v-for="(item, index) in visibleItems"
        :key="index"
        :effect="tagEffect"
        :type="tagType"
        :size="tagSize"
    >
      <el-tooltip class="item" effect="dark" :content="item" placement="top">
        <span>{{ truncate(item, truncateLength) }}</span>
      </el-tooltip>
    </el-tag>

    <!-- 显示更多提示 -->
    <el-popover
        v-if="hasMoreItems"
        placement="top"
        width="150"
        trigger="hover"
    >
      <div class="custom-tag-list flex-column-temp">
        <el-tag
            v-for="(item, index) in items.slice(visibleItems.length)"
            :key="index"
            :effect="tagEffect"
            :type="tagType"
            :size="tagSize"
        >
          <el-tooltip class="item" effect="dark" :content="item" placement="top">
            <span>{{ truncate(item, truncateLength) }}</span>
          </el-tooltip>
        </el-tag>
      </div>
      <el-tag class="more-tag" :size="tagSize" slot="reference">+{{ remainingItemCount }} 更多</el-tag>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'Tags',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    maxVisible: {
      type: Number,
      default: 3, // 默认最多显示 3 个标签
    },
    truncateLength: {
      type: Number,
      default: 6, // 默认截断长度为 6
    },
    tagType: {
      type: String,
      default: 'info', // 标签的默认类型
    },
    tagEffect: {
      type: String,
      default: 'plain', // 标签效果：plain, dark, light
    },
    tagSize: {
      type: String,
      default: 'mini', // 标签的默认大小
    },
  },
  computed: {
    visibleItems() {
      return this.items.slice(0, this.maxVisible);
    },
    remainingItemCount() {
      return this.items.length - this.visibleItems.length;
    },
    hasMoreItems() {
      return this.items.length > this.visibleItems.length;
    },
  },
  methods: {
    truncate(text, maxLength) {
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
  },
};
</script>

<style scoped>
.custom-tag-list {
  display: flex;
  gap: 5px;
  flex-wrap: nowrap;
  overflow: hidden;
  white-space: nowrap;
  align-items: center;
}

.el-tag {
  margin-left: 0 !important;
}

.more-tag {
  font-size: 12px;
  margin-bottom: -1px;
  color: #66b1ff;
}

.flex-column-temp {
  flex-flow: column;
}
</style>
